import React from 'react';

const Home = ( {selectedText} ) => {
  return (
    <>
      <h1>{selectedText || 'Tentang'}</h1>
      <p>Malas ngoding njir</p>
    </>
  );
};

export default Home;
